export default "__VITE_PUBLIC_ASSET__66c04ad6__"